module.exports = __webpack_public_path__ + "static/img/google_auth.d7024e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/google_auth.png
// module id = ON+z
// module chunks = 1